import { Locale } from '@ps-smart-cp/ppfw-client';

const numberingMethodClassConfig = {
  enterDirectly: new Map([[Locale.ja, '直接入力する']]),
  automaticNumbering: new Map([[Locale.ja, '自動採番する']]),
  notChange: new Map([[Locale.ja, '変更しない']]),
};

export { numberingMethodClassConfig };
